// extracted by mini-css-extract-plugin
module.exports = {"dialogStore":"DialogApplicableStore_dialogStore_3kc8a"};